/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
	EvaluationDTORequestResponse,
	EvaluationDTORequestResponseFromJSON,
	EvaluationDTORequestResponseToJSON,
	RequestResponse,
	RequestResponseFromJSON,
	RequestResponseToJSON,
	UpdateEvaluationDTO,
	UpdateEvaluationDTOFromJSON,
	UpdateEvaluationDTOToJSON,
} from "../models";

export interface ApiEvaluationAddEvaluationPostRequest {
	updateEvaluationDTO?: UpdateEvaluationDTO;
}

export interface ApiEvaluationGetUsersEvaluationByYearUserIdGetRequest {
	userId: string;
	year?: number;
}

export interface ApiEvaluationUpdateEvaluationIdPutRequest {
	id: string;
	updateEvaluationDTO?: UpdateEvaluationDTO;
}

/**
 *
 */
export class EvaluationApi extends runtime.BaseAPI {
	/**
	 */
	async apiEvaluationAddEvaluationPostRaw(
		requestParameters: ApiEvaluationAddEvaluationPostRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<RequestResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters["Content-Type"] = "application/json";

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Evaluation/AddEvaluation`,
				method: "POST",
				headers: headerParameters,
				query: queryParameters,
				body: UpdateEvaluationDTOToJSON(requestParameters.updateEvaluationDTO),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			RequestResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiEvaluationAddEvaluationPost(
		requestParameters: ApiEvaluationAddEvaluationPostRequest = {},
		initOverrides?: RequestInit
	): Promise<RequestResponse> {
		const response = await this.apiEvaluationAddEvaluationPostRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 */
	async apiEvaluationGetUsersEvaluationByYearUserIdGetRaw(
		requestParameters: ApiEvaluationGetUsersEvaluationByYearUserIdGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<EvaluationDTORequestResponse>> {
		if (
			requestParameters.userId === null ||
			requestParameters.userId === undefined
		) {
			throw new runtime.RequiredError(
				"userId",
				"Required parameter requestParameters.userId was null or undefined when calling apiEvaluationGetUsersEvaluationByYearUserIdGet."
			);
		}

		const queryParameters: any = {};

		if (requestParameters.year !== undefined) {
			queryParameters["year"] = requestParameters.year;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Evaluation/GetUsersEvaluationByYear/{userId}`.replace(
					`{${"userId"}}`,
					encodeURIComponent(String(requestParameters.userId))
				),
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			EvaluationDTORequestResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiEvaluationGetUsersEvaluationByYearUserIdGet(
		requestParameters: ApiEvaluationGetUsersEvaluationByYearUserIdGetRequest,
		initOverrides?: RequestInit
	): Promise<EvaluationDTORequestResponse> {
		const response =
			await this.apiEvaluationGetUsersEvaluationByYearUserIdGetRaw(
				requestParameters,
				initOverrides
			);
		return await response.value();
	}

	/**
	 */
	async apiEvaluationUpdateEvaluationIdPutRaw(
		requestParameters: ApiEvaluationUpdateEvaluationIdPutRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<RequestResponse>> {
		if (requestParameters.id === null || requestParameters.id === undefined) {
			throw new runtime.RequiredError(
				"id",
				"Required parameter requestParameters.id was null or undefined when calling apiEvaluationUpdateEvaluationIdPut."
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters["Content-Type"] = "application/json";

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/Evaluation/UpdateEvaluation/{id}`.replace(
					`{${"id"}}`,
					encodeURIComponent(String(requestParameters.id))
				),
				method: "PUT",
				headers: headerParameters,
				query: queryParameters,
				body: UpdateEvaluationDTOToJSON(requestParameters.updateEvaluationDTO),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			RequestResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiEvaluationUpdateEvaluationIdPut(
		requestParameters: ApiEvaluationUpdateEvaluationIdPutRequest,
		initOverrides?: RequestInit
	): Promise<RequestResponse> {
		const response = await this.apiEvaluationUpdateEvaluationIdPutRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}
}
